import { useTranslation } from 'react-i18next'

export const RecommendedBadge = () => {
  const { t } = useTranslation()

  return (
    <span className="w-fit rounded-pill bg-purple100 px-spacing8 py-spacing2 text-caption font-semibold text-purple700">
      {t('Mais recomendado')}
    </span>
  )
}
